import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'file-input',
  templateUrl: './file-input.component.html',
  styleUrl: './file-input.component.scss',
})
export class FileInputComponent {
  @Input() file;
  @Input() fileIndex;
  @Input() fileName = 'certificate';
  @Input() fileLabel = 'certificate_file';
  @Input() acceptTypes: string = 'image/jpeg,image/png,application/pdf';
  @Input() maxSize: number = 5000000; // 5MB default
  @Input() deleting = false;
  @Input() canDelete = true;
  @Output() delete = new EventEmitter();
  @Output() save = new EventEmitter();

  deleteFile(fileId, index) {
    if (this.deleting) return;
    this.delete.emit({ fileId, index });
  }

  handleFileInput(files: FileList, fileId: any, index: number) {
    this.file.error = false;
    const file = files[0];

    // check file size
    if (file.size > this.maxSize) {
      this.file.error = true;
      const maxSizeMB = (this.maxSize / (1024 * 1024)).toFixed(0);
      this.file.errorMessage = `عفوا لا يمكن رفع صور حجم اكبر من ${maxSizeMB}MB`;
      return;
    }

    // check file type
    const allowedTypes = this.acceptTypes.split(',');
    if (!allowedTypes.includes(file.type)) {
      this.file.error = true;
      this.file.errorMessage = 'عفوا نوع الملف غير مدعوم';
      return;
    }

    // all good
    this.save.emit({ files, fileId, index });
  }
}
